// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_logged_in_as = /** @type {(inputs: {}) => string} */ () => {
	return `Logged in as:`
};

const de_widget_logged_in_as = /** @type {(inputs: {}) => string} */ () => {
	return `Eingeloggt als:`
};

const es_widget_logged_in_as = /** @type {(inputs: {}) => string} */ () => {
	return `Conectado como:`
};

const fr_widget_logged_in_as = /** @type {(inputs: {}) => string} */ () => {
	return `Connecté en tant que:`
};

const fi_widget_logged_in_as = /** @type {(inputs: {}) => string} */ () => {
	return `Kirjautunut käyttäjänä:`
};

const ja_widget_logged_in_as = /** @type {(inputs: {}) => string} */ () => {
	return `ログイン中：`
};

const nl_widget_logged_in_as = /** @type {(inputs: {}) => string} */ () => {
	return `Ingelogd als:`
};

const pt_widget_logged_in_as = /** @type {(inputs: {}) => string} */ () => {
	return `Sessão iniciada como:`
};

const ro_widget_logged_in_as = /** @type {(inputs: {}) => string} */ () => {
	return `Conectat ca:`
};

const th_widget_logged_in_as = /** @type {(inputs: {}) => string} */ () => {
	return `เข้าสู่ระบบในชื่อ:`
};

const ur_widget_logged_in_as = /** @type {(inputs: {}) => string} */ () => {
	return `بطور لاگ ان:`
};

const zh_hant1_widget_logged_in_as = /** @type {(inputs: {}) => string} */ () => {
	return `登入身份：`
};

const da_widget_logged_in_as = /** @type {(inputs: {}) => string} */ () => {
	return `Logget ind som:`
};

const it_widget_logged_in_as = /** @type {(inputs: {}) => string} */ () => {
	return `Connesso come:`
};

const vn_widget_logged_in_as = /** @type {(inputs: {}) => string} */ () => {
	return `Đã đăng nhập với tên:`
};

const ko_widget_logged_in_as = /** @type {(inputs: {}) => string} */ () => {
	return `로그인:`
};

const tr_widget_logged_in_as = /** @type {(inputs: {}) => string} */ () => {
	return `Giriş yapılan hesap:`
};

const lv_widget_logged_in_as = /** @type {(inputs: {}) => string} */ () => {
	return `Ielogojies kā:`
};

const ar_widget_logged_in_as = /** @type {(inputs: {}) => string} */ () => {
	return `مسجل الدخول كـ:`
};

const bs_widget_logged_in_as = /** @type {(inputs: {}) => string} */ () => {
	return `Prijavljen kao:`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_logged_in_as = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_logged_in_as(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_logged_in_as", locale)
	if (locale === "en") return en_widget_logged_in_as(inputs)
	if (locale === "de") return de_widget_logged_in_as(inputs)
	if (locale === "es") return es_widget_logged_in_as(inputs)
	if (locale === "fr") return fr_widget_logged_in_as(inputs)
	if (locale === "fi") return fi_widget_logged_in_as(inputs)
	if (locale === "ja") return ja_widget_logged_in_as(inputs)
	if (locale === "nl") return nl_widget_logged_in_as(inputs)
	if (locale === "pt") return pt_widget_logged_in_as(inputs)
	if (locale === "ro") return ro_widget_logged_in_as(inputs)
	if (locale === "th") return th_widget_logged_in_as(inputs)
	if (locale === "ur") return ur_widget_logged_in_as(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_logged_in_as(inputs)
	if (locale === "da") return da_widget_logged_in_as(inputs)
	if (locale === "it") return it_widget_logged_in_as(inputs)
	if (locale === "vn") return vn_widget_logged_in_as(inputs)
	if (locale === "ko") return ko_widget_logged_in_as(inputs)
	if (locale === "tr") return tr_widget_logged_in_as(inputs)
	if (locale === "lv") return lv_widget_logged_in_as(inputs)
	if (locale === "ar") return ar_widget_logged_in_as(inputs)
	if (locale === "bs") return bs_widget_logged_in_as(inputs)
	return "widget_logged_in_as"
};